if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super()

      this.form = this.querySelector('form')
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.headerCartCount = document.getElementById('cart-icon-bubble').querySelector('span:first-child').childNodes[1];
    }

    getSectionsToRender() {
      return [
        {
          id: 'mini-cart',
          section: document.getElementById('mini-cart').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
      ]
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML
    }

    onSubmitHandler(evt) {
      evt.preventDefault()

      const submitButton = this.querySelector('[type="submit"]')
      const statusBlock = document.querySelector('product-totals')

      submitButton.setAttribute('disabled', true)

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      })

      let drawerOpened = false
      const openDrawer = () => {
        if (drawerOpened) return
        drawerOpened = true
        document.querySelector('mini-cart-toggle').open()
      }

      const fallbackTimer = setTimeout(openDrawer, 300)

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => {
          if (!response.ok) throw new Error(`Cart add failed: ${response.status}`)
          return response.text()
        })
        .then((state) => {
          const parsedState = JSON.parse(state)

          const cartItems = window.__CART__.items
          let alreadyInCart = false
          if (cartItems.length) {
            window.__CART__.items.map((item) => {
              if (item.id === parsedState.id) {
                item.quantity = parsedState.quantity
                alreadyInCart = true
              }
            })
          }
          if (!alreadyInCart) {
            window.__CART__.items.push(parsedState)
          }
          window.__CART__.item_count = window.__CART__.items.reduce(
            (total, item) => total + item.quantity, 0
          )

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id)
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            )
          })

          clearTimeout(fallbackTimer)
          openDrawer()

          document.getElementById('cart-icon-bubble').classList.add('open-by-adding')
          document.getElementById('cart-icon-bubble').click()
        })
        .catch((e) => {
          console.error(e)
          clearTimeout(fallbackTimer)
          if (drawerOpened) {
            document.querySelector('mini-cart-toggle').close()
          }
        })
        .finally(() => {
          submitButton.removeAttribute('disabled')
          statusBlock?.updateText(JSON.parse(body)?.quantity)
          this.headerCartCount.nodeValue = window.__CART__.item_count
        })
    }
  }

  customElements.define('product-form', ProductForm)
}
